import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { SiteControllerSettingBeds24PriceAndStockDataSync_SettingPage_Mutation } from "./mutation";

type Props = {
	hotelID: string;
};

export const useSyncPriceAndStockDataBeds24 = ({ hotelID }: Props) => {
	const { mutationFunc } = useCustomMutation(SiteControllerSettingBeds24PriceAndStockDataSync_SettingPage_Mutation);

	const onSyncPriceAndStockData = useCallback(async () => {
		return await mutationFunc({
			variables: {
				hotelID,
			},
		});
	}, [hotelID, mutationFunc]);

	return { onSyncPriceAndStockData };
};
